// extracted by mini-css-extract-plugin
export var statItem = "_lt-1";
export var statsRow = "_lt-0";